// imports section Start
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  Stack,
  TextField,
  Checkbox,
  FormControlLabel,
  FormGroup,
  Link,
  InputAdornment,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useStyles, lightTheme } from "../../assets/styles/Theme";
// import PointOfOrderImage from "../../assets/images/login_bg.jpg";
import login_bg_1 from "../../assets/images/login_bg_1.jpg";
import login_bg_2 from "../../assets/images/login_bg_2.jpg";
import login_bg_3 from "../../assets/images/login_bg_3.jpg";
import login_bg_4 from "../../assets/images/login_bg_4.jpg";
import login_bg_5 from "../../assets/images/login_bg_5.jpg";
import lg_pizza from "../../assets/images/lg_burger.png";
import shield from "../../assets/images/shield.jpg";
import shield2 from "../../assets/images/shield2.png";
import { Person, Lock, AccountCircle } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { LOGIN_API } from "../../api/ApiModel";
import { setUserParams } from "../../store/ReduxUser";

import { externalpostApi } from "../../services/external/externalApis";
import { useDispatch } from "react-redux";
import { CON_MODULE_SYSADMIN,CON_MODULEKEY } from "../../utils/sys/Constants";
import { setAccessRights } from "../../store/ReduxAccessRight";
import { setAccessModules } from "../../store/ReduxAccessModules";
import { setCashierUserRefCode } from "../../store/ReduxCashierCartReducer";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import { LOGIN_FAILED, LOGIN_SUCCESS } from "../../utils/sys/Messages";
import { ThemeProvider } from "@mui/material/styles";
// imports section End

const preventDefault = (event) => event.preventDefault();

function Login() {
  // Hooks start
  const theme = useTheme();
  const styles = useStyles(theme);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [snackbarOpen, setSnackbarOpen] = useState(false); // Control Snackbar visibility
  const [snackbarMessage, setSnackbarMessage] = useState(""); // Snackbar message
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  // Hooks end

  // Handlers start
  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  // Custom Image Slider Component
  const ImageSlider = () => {
    const images = [login_bg_1, login_bg_2, login_bg_3, login_bg_4, login_bg_5];
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    useEffect(() => {
      const interval = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
      }, 3000);

      return () => clearInterval(interval);
    }, []);

    return (
      <Box
        component="img"
        src={images[currentImageIndex]}
        // src={login_bg_3}
        alt="Point of Order System"
        sx={{
          transition: "opacity 1s ease-in-out",

          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 2,

          position: "relative",
          // animation: "slideIn 3s ease-in-out forwards",
          "@keyframes slideIn": {
            "0%": { transform: "translateX(-100%)" }, // Starts off-screen from left
            "100%": { transform: "translateX(0)" }, // Ends at the normal position
          },
        }}
      />
    );
  };
  // Handlers end

  // API calls start
  const handleLogin = async () => {
    try {
      var loginResponse = await externalpostApi(LOGIN_API, {
        username,
        password,
        appModule: CON_MODULE_SYSADMIN,
        appToken: CON_MODULEKEY,
      });

      loginResponse = loginResponse.value;

      const userData = loginResponse.user;
      const accessRightsData = loginResponse.accessRights;
      const accessModulesData = loginResponse.accessModules;


      // Dispatch user data and access rights to redux
      dispatch(setUserParams(userData));
      dispatch(setAccessRights(accessRightsData)); // Dispatch access rights
      dispatch(setAccessModules(accessModulesData));
      setSnackbarMessage(LOGIN_SUCCESS);
      setSnackbarSeverity("success");
      setSnackbarOpen(true);

      navigate("/home", {
        state: { snackbarMessage: LOGIN_SUCCESS, snackbarSeverity: "success" },
      });
    } catch (error) {
      console.error("Login failed:", error);
      setError("Login failed. Please check your credentials and try again.");
      setSnackbarMessage(LOGIN_FAILED);
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };
  // API calls end

  return (
    <ThemeProvider theme={lightTheme}>
      <Box sx={styles.login_container}>
        {/* Background Shape Animation */}
        <Box sx={styles.shape1}>
          <Box
            component="img"
            src={shield2}
            alt="Point of Order System"
            sx={styles.img_lg_card_shape1}
          />
        </Box>
        <Box sx={styles.shape2}>
          <Box
            component="img"
            src={shield}
            alt="Point of Order System"
            sx={styles.img_lg_card_shape1}
          />
        </Box>
        <Grid container sx={styles.login_card_container}>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            sx={styles.login_card_left}
          >
            {/* New Image */}
            {/* <Box
              component="img"
              src={PointOfOrderImage}
              alt="Point of Order System"
              sx={styles.img_login_card}
            /> */}

            <ImageSlider />
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            xl={6}
            sx={styles.login_card_right}
          >
            <Typography variant="h1" sx={styles.retro_text}>
              Hello,
            </Typography>
            <Typography variant="h2" sx={styles.retro_text}>
              Welcome Back!
            </Typography>

            <Box
              component="form"
              sx={{
                "& > :not(style)": { my: 3 },
              }}
              noValidate
              autoComplete="off"
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <AccountCircle
                  sx={{ color: theme.palette.text.icons, mr: 1, my: 0.5 }}
                />
                <TextField
                  id="txtUsername"
                  label="Username"
                  variant="outlined"
                  fullWidth
                  size="small"
                  // value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  // InputProps={{
                  //   sx: {
                  //     "& .MuiInput-underline:before": {
                  //       borderBottomColor: "#1E90FF",
                  //     },
                  //     "& .MuiInput-underline:hover:before": {
                  //       borderBottomColor: "#1C86EE",
                  //     },
                  //     "& .MuiInput-underline:after": {
                  //       borderBottomColor: "#1E90FF",
                  //     },
                  //   },
                  // }}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Lock
                  sx={{ color: theme.palette.text.icons, mr: 1, my: 0.5 }}
                />
                <TextField
                  id="txtPassword"
                  label="Password"
                  size="small"
                  type="password"
                  variant="outlined"
                  fullWidth
                  // value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  // InputProps={{
                  //   sx: {
                  //     "& .MuiInput-underline:before": {
                  //       borderBottomColor: "#1E90FF",
                  //     },
                  //     "& .MuiInput-underline:hover:before": {
                  //       borderBottomColor: "#1C86EE",
                  //     },
                  //     "& .MuiInput-underline:after": {
                  //       borderBottomColor: "#1E90FF",
                  //     },
                  //   },
                  // }}
                />
              </Box>
            </Box>
            {error && (
              <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                {error}
              </Typography>
            )}
            {/* <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              typography: "body1",
              gap: 1,
            }}
            onClick={preventDefault}
          >
            <Typography sx={styles.forgot_password}>Forgot</Typography>
            <Link href="#" sx={styles.forgot_password}>
              {" "}
              Password?
            </Link>
          </Box> */}

            <Stack
              spacing={2}
              direction="row"
              mt={4}
              justifyContent={"flex-end"}
            >
              {/* <FormGroup>
              <FormControlLabel
                control={<Checkbox />}
                label="keep me logged in"
                sx={{ color: "#1E90FF" }}
              />
            </FormGroup> */}

              <Button
                fullWidth
                onClick={handleLogin}
                variant="contained"
                size="medium"
                sx={styles.login_btn}
              >
                Log In
              </Button>
            </Stack>
          </Grid>
        </Grid>
        <SnackbarMessage
          open={snackbarOpen}
          handleClose={handleCloseSnackbar}
          message={snackbarMessage}
          severity={snackbarSeverity} // Dynamic severity (success or error)
        />
      </Box>{" "}
    </ThemeProvider>
  );
}

export default Login;
